import StudentList from "@/controllers/student/student-list.js";
import store from '../../../store';
import CONFIG from "@/assets/js/config.custom.js";
import {
  mapGetters
} from "vuex";
import axios from "axios";

export default {
  extends: StudentList,
  data() {
    return {
      student_no: '',
      deactivationStudentId: null,
      deactivationReason: '',
      deactivationReasonError: false,
      pendingDeactivationId: null,
      hasSiblingDiscountWarning: false,
      siblingDiscountMessage: '',
      isFinalYear: false,
      passFailStudentIds: [],
    };
  },
  created() {
    // Check if redirected from status change
    if (sessionStorage.getItem('statusChangeSuccess') === '1') {
      sessionStorage.removeItem('statusChangeSuccess');
      this.$notification.success('Student status updated successfully.', {
        timer: 3,
        position: "bottomCenter"
      });
    }
  },

  computed: {
    ...mapGetters(['getUser']),
    searchParams() {
      return {
        name: this.name,
        number: this.student_no,
        parent_no: this.parentNo,
        phone: this.phone,
        grade_id: this.grade_id,
        section_id: this.section_id,
        gender: this.gender,
        year: this.year,
        campus_id: store.state.user.campus_id,
      };
    },
  },

  methods: {
    ...StudentList.methods,

    getStatusText(status) {
      return CONFIG.STUDENT_STATUS_TEXT[status] || '-';
    },

    downloadImportTemplate() {
      this.isLoading = true;
      axios.get('student/excelTemplateDownload', {
        responseType: 'blob',
      }).then((response) => {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `student_import_template_${new Date().toISOString().slice(0, 10)}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }).catch((error) => {
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },

    formatPeriodNames(periodNames) {
      if (!periodNames) {
        return '';
      }
      return String(periodNames).split(',').map((name) => name.trim()).filter(Boolean).join('\n');
    },

    searchStudent() {
      this.isLoading = true;
      this.searchSelectedCb = [];
      this.checkAll = false;
      this.unSelectedCb = [];
      this.idArray = [];
      this.nextPageCheckAll = false;
      this.$router.replace({
        query: {
          ...this.$route.query,
          active_page: 1,
          leaved_page: 1,
          name: this.name || undefined,
          parent_no: this.parentNo || undefined,
          phone: this.phone || undefined,
          grade_id: this.grade_id || undefined,
          section_id: this.section_id || undefined,
          gender: this.gender || undefined,
          year: this.year || undefined,
          search_status: true,
          leaved_search_status: true,
          number: this.student_no,
        }
      });
      this.searchedData = this.searchParams;
      this.isSearched = true;
      this.searchActiveStudent(1);
      this.searchLeavedStudent(1);
    },

    reset() {
      this.name = '';
      this.parentNo = '';
      this.phone = '',
      this.selectedGrade = 0;
      this.selectedSection = 0;
      this.selectedGender = 0;
      this.selectedYear = 0;
      this.grade_id = '';
      this.section_id = '';
      this.gender = '';
      this.year = '';
      this.search_status = false;
      this.leaved_search_status = false;
      this.student_no = '';
      this.gradeArr = this.sectionArr = [{ id: 0, text: "All" }];

      this.$router.replace({
        query: {}
      });
      this.isLoading = true;
      this.getStudentList(1);
      this.getLeavedStudentList(1);
      this.isSearched = false;
    },

    addRow(gradeResult, rowIndex) {
      this.tmpClasses = [];
      this.tmpClasses = gradeResult.slice(0);
      this.tmpClasses.splice(0, 1);

      var table = document.getElementById('active-table');
      var originalRowCount = table.rows.length;
      var afterRow = document.getElementsByClassName('row-' + (rowIndex + 1));
      var checkedRow = document.getElementsByClassName('row-' + rowIndex);
      var rowTd = checkedRow[0].children;

      const isAdmin = this.auth('admin').check();
      const classColIndex = isAdmin ? 6 : 5;
      const resultColIndex = isAdmin ? 7 : 6;
      const actionColIndex = isAdmin ? 8 : 7;

      for (let i = 0; i < actionColIndex; i++) {
        if (i === classColIndex || i === resultColIndex) continue;

        rowTd[i].setAttribute('rowspan', this.tmpClasses.length + 1);
        // Keep col-acd-period (and other classes); only add rowspan helper class.
        rowTd[i].classList.add('addSpan');
      }
      var fragment = document.createDocumentFragment();
      this.tmpClasses.forEach(e => {
        var newRow = document.createElement("tr");
        newRow.classList.add('row-add', `row-add-${rowIndex}`);
        var rowTpl = `
        <td data-label="Class Name">
            ${e.grade}
        </td>
        <td data-label="Exam Result" class="exam-result">
              ${e.status}
        </td>
        `
        newRow.innerHTML = rowTpl;

        fragment.appendChild(newRow);
      })
      if (rowIndex < originalRowCount - 1) {
        table.tBodies[0].insertBefore(fragment, afterRow[0]);
      } else {
        table.tBodies[0].appendChild(fragment);
      }
    },

    removeRow(rowIndex) {
      const addedRows = document.getElementsByClassName(`row-add-${rowIndex}`);
      Array.from(addedRows).forEach(el => el.remove());

      const mainRow = document.getElementsByClassName('row-' + rowIndex)[0];
      if (mainRow) {
        const rowTds = mainRow.children;
        const isAdmin = this.can('STUDENT', 'setResult');
        const classColIndex = isAdmin ? 6 : 5;
        const resultColIndex = isAdmin ? 7 : 6;
        const actionColIndex = isAdmin ? 8 : 7;

        for (let i = 0; i < actionColIndex; i++) {
          if (i === classColIndex || i === resultColIndex) continue;
          rowTds[i].removeAttribute('rowspan');
          // Do not wipe col-acd-period; only remove the rowspan helper class.
          rowTds[i].classList.remove('addSpan');
        }
      }
    },

    showRestore(id) {
      this.$router.push({
        name: "studentRestore",
        params: {
          id: id
        }
      });
    },

    async confirmDeactivate(id) {
      this.isLoading = true;
      try {
        await axios.post(`/student/deactivate/${id}`);

        this.isLoading = false;
        this.openDeactivateReasonModal(id);

      } catch (error) {
        this.isLoading = false;
        if (error.response && error.response.status === 422 && error.response.data.requires_confirmation) {
          this.siblingDiscountMessage = error.response.data.message || '';
          this.hasSiblingDiscountWarning = true;
          this.pendingDeactivationId = id;
          this.$bvModal.show('modal-deactivate-warning');
        } else {
          let errorMessage = 'An unexpected error occurred.';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          this.$notification.error(errorMessage, {
            timer: 3,
            position: "bottomCenter"
          });
        }
      }
    },

    proceedWithDeactivateAfterWarning() {
      this.$bvModal.hide('modal-deactivate-warning');
      this.hasSiblingDiscountWarning = false;
      this.siblingDiscountMessage = '';
      const id = this.pendingDeactivationId;
      this.pendingDeactivationId = null;
      this.openDeactivateReasonModal(id);
    },

    cancelDeactivateAfterWarning() {
      this.$bvModal.hide('modal-deactivate-warning');
      this.hasSiblingDiscountWarning = false;
      this.siblingDiscountMessage = '';
      this.pendingDeactivationId = null;
    },

    openDeactivateReasonModal(id) {
      this.deactivationStudentId = id;
      this.deactivationReason = '';
      this.deactivationReasonError = false;
      this.$bvModal.show('modal-deactivate-reason');
    },

    cancelDeactivate() {
      this.deactivationStudentId = null;
      this.deactivationReason = '';
      this.deactivationReasonError = false;
      this.$bvModal.hide('modal-deactivate-reason');
    },

    async confirmDeactivationReason() {
      if (!this.deactivationReason) {
        this.deactivationReasonError = true;
        return;
      }
      this.deactivationReasonError = false;
      const id = this.deactivationStudentId;
      const reason = this.deactivationReason;

      this.$bvModal.hide('modal-deactivate-reason');
      this.isLoading = true;
      try {
        await axios.post(`/student/deactivate/${id}`, {
          force_deactivate: 1,
          reason: reason
        });
        this.deactivationStudentId = null;
        this.deactivationReason = '';
        this.refreshStudentLists();
        this.$notification.success('Student Deactivated Successfully', {
          timer: 3,
          position: "bottomCenter"
        });
      } catch (error) {
        let errorMessage = 'An error occurred while deactivating the student.';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        this.$notification.error(errorMessage, {
          timer: 3,
          position: "bottomCenter"
        });
      } finally {
        this.isLoading = false;
      }
    },

    refreshStudentLists() {
      this.isLoading = true;
      let activePage = parseInt(this.$route.query.active_page) || 1;
      let leavedPage = parseInt(this.$route.query.leaved_page) || 1;

      if (document.querySelector('#active-table tbody').children.length <= 1 && activePage > 1) {
        activePage -= 1;
        this.$router.replace({ query: { ...this.$route.query, active_page: activePage } });
      }

      if (this.isSearched) {
        this.searchActiveStudent(activePage);
        this.searchLeavedStudent(leavedPage);
      } else {
        this.getStudentList(activePage);
        this.getLeavedStudentList(leavedPage);
      }
    },

    proceedFinalYearPass() {
      this.$bvModal.hide('modal-final-year-warning');
      this.passFailDisable = true;
      this.isLoading = true;

      let activePage = parseInt(this.$route.query.active_page) || 1;
      let leavedPage = parseInt(this.$route.query.leaved_page) || 1;

      const activeTableBody = document.querySelector('#active-table tbody');
      if (activeTableBody && activeTableBody.children.length === 1 && activePage > 1) {
        activePage -= 1;
        leavedPage = Math.max((parseInt(this.$route.query.leaved_page) || 1) - 1, 1);
        this.$router.replace({
          query: {
            ...this.$route.query,
            active_page: activePage,
            leaved_page: leavedPage
          },
        });
      }

      let request = {
        search_status: this.search_status,
        checkAll: this.checkAll,
        nextPageCheckAll: this.nextPageCheckAll,
        unSelectedCb: this.unSelectedCb,
        student_ids: this.passFailStudentIds,
        result: this.passFailResult,
        campusMaxGrade: this.maxGradeId,
        campus_id: store.state.user.campus_id,
        created_id: store.state.user.id,
        selected_class_id: 0,
        selected_year_id: 0
      };

      if (this.search_status) {
        const searchRequest = {
          name: this.name,
          parent_no: this.parentNo,
          phone: this.phone,
          grade_id: this.grade_id,
          section_id: this.section_id,
          gender: this.gender,
          year: this.year,
          campus_id: store.state.user.campus_id,
          leavedStatus: false
        };
        request = Object.assign({}, searchRequest, request);
      }

      axios.post("/student/setPassFail", request, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(response => {
          if (response.data && response.data.success == true) {
            this.checkAll = false;
            this.selectedCb = [];
            this.searchSelectedCb = [];

            if (this.search_status) {
              this.restoreFiltersFromQuery();
              this.searchActiveStudent(activePage);
            } else {
              this.getStudentList(activePage);
            }

            if (this.leaved_search_status) {
              this.restoreFiltersFromQuery();
              this.searchLeavedStudent(leavedPage);
            } else {
              this.getLeavedStudentList(leavedPage);
            }

            this.$notification.success("Student Graduated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
          } else {
            alert(response.data.msg);
          }
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          console.log("Student Graduation API Error", error);
        })
        .finally(() => {
          this.isLoading = false;
          this.passFailDisable = false;
        });
    },

    checkPassFailValidate(idArr, result) {
      this.passFailDisable = true;
      this.passFailResult = result;
      this.passFailStudentIds = idArr;
      var request = {
        search_status: this.search_status,
        checkAll: this.checkAll,
        nextPageCheckAll: this.nextPageCheckAll,
        unSelectedCb: this.unSelectedCb,
        student_ids: idArr,
        result: result,
        campusMaxGrade: this.maxGradeId,
        campus_id: store.state.user.campus_id,
        created_id: store.state.user.id
      }

      if (this.search_status) {
        var searchRequest = {
          name: this.name,
          parent_no: this.parentNo,
          phone: this.phone,
          grade_id: this.grade_id,
          section_id: this.section_id,
          gender: this.gender,
          year: this.year,
          campus_id: store.state.user.campus_id,
          leavedStatus: false
        }
        request = Object.assign({}, searchRequest, request);
      }

      axios.post("/student/checkPassFail", request, {
        headers: {
          'Content-Type': 'application/json',
        }
      }).then(response => {
        if (response.data.success == true) {
          this.passFailDisable = false;
          this.isFinalYear = response.data.is_final_year || false;

          // If final year student and passing, show warning first
          if (this.isFinalYear && result == 1) {
            this.$bvModal.show('modal-final-year-warning');
            return;
          }

          if (response.data.has_pre_reg) {
            this.hasPreRegistration = true;
            this.year_id = response.data.pre_reg_year_id;
            this.getClass(this.year_id);
            setTimeout(() => {
                this.class_id = response.data.pre_reg_class_id;
            }, 500);
          } else {
            this.hasPreRegistration = false;
            this.year_id = 0;
            this.class_id = 0;
          }
          this.$bvModal.show('modal-1');
        }
      })
        .catch(error => {
          this.passFailDisable = false;
          if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            let message = error.response.data.message + '\n\n' + errors['student_ids'];

            alert(message.trim());
          } else {
            alert('An unexpected error occurred.');
          }
        });
    },

    deleteFormerStudent(studentId) {
      let activePage = parseInt(this.$route.query.active_page) || 1;
      let leavedPage = parseInt(this.$route.query.leaved_page) || 1;

      if (document.querySelector('#active-table tbody').children.length == 1) {
        activePage = activePage - 1;
        leavedPage = leavedPage - 1;
        this.$router.replace({
          query: {
            active_page: activePage,
            leaved_page: leavedPage,
          },
        })
      }

      axios.delete("/student/delete-former/" + studentId)
        .then(response => {
          if (response.data.success == true) {
            this.isLoading = true;
            if (this.search_status) {
              this.restoreFiltersFromQuery();
              this.searchActiveStudent(activePage);
            } else {
              this.getStudentList(activePage);
            }

            if (this.leaved_search_status) {
              this.restoreFiltersFromQuery();
              this.searchLeavedStudent(leavedPage);
            } else {
              this.getLeavedStudentList(leavedPage);
            }
            this.$notification.success('Student Deleted Successfully', {
              timer: 3,
              position: "bottomCenter"
            });
          } else {
            this.$notification.error('Unable to delete student.', {
              timer: 3,
              position: "bottomCenter"
            });
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Student Delete Error->", error);
        });
    },
  },
};
